{
  "user": {
    "Detayları Düzenle": "Detayları Düzenle",
    "Foto": "Foto",
    "Hesap": "Hesap",
    "Mevcut Şifre": "Mevcut Şifre",
    "Profil": "Profil",
    "Yeni Resim Yükle": "Yeni Resim Yükle",
    "Şifre Değiştirme": "Şifre Değiştirme",
    "Şifre Kontrol": "Şifre Kontrol",
    "Bildirim İzinleri": "Bildirim İzinleri",
    "Bu Cihaz": "Bu Cihaz",
    "Bu cihazdan bildirim alıp almayacağınızı buradan yönetebilirsiniz.": "Bu cihazdan bildirim alıp almayacağınızı buradan yönetebilirsiniz.",
    "desc_notification_manage": "Bu cihazdan bildirim alıp almayacağınızı buradan yönetebilirsiniz.",
    "Bildirimleri Kapat": "Bildirimleri Kapat",
    "Bildirimleri Aç": "Bildirimleri Aç",
    "Tarayıcınız bildirimleri desteklemiyor": "Tarayıcınız bildirimleri desteklemiyor.",
    "Bildirim izni reddedildi Tarayıcı ayarlarından izin verin": "Bildirim izni reddedildi. Tarayıcı ayarlarından izin verin.",
    "Kayıtlı Cihazlar": "Kayıtlı Cihazlar",
    "Cihaz Bilgisi": "Cihaz Bilgisi",
    "Kayıt Tarihi": "Kayıt Tarihi",
    "Son Erişim": "Son Erişim",
    "İşlem": "İşlem",
    "Bilinmeyen Cihaz": "Bilinmeyen Cihaz",
    "Kayıtlı cihaz bulunamadı": "Kayıtlı cihaz bulunamadı.",
    "Cihaz listesi alınamadı": "Cihaz listesi alınamadı.",
    "Bu cihazın bildirim aboneliğini silmek istediğinize emin misiniz": "Bu cihazın bildirim aboneliğini silmek istediğinize emin misiniz?",
    "Cihaz silindi": "Cihaz silindi.",
    "Cihaz silinemedi": "Cihaz silinemedi."
  }
}
